import styled from '@emotion/styled';
import { Paper } from '@mantine/core';

export const OutputCard = styled(Paper)<any>(({ theme }) => ({
  backgroundColor:
    theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
  borderColor:
    theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
}));
